import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import * as process from "process";

const instance = axios.create({
  baseURL: process.env.NEXT_PUBLIC_SERVICE_URL,
});

export const sendNVFOTP = createAsyncThunk<any, any>(
  "sendNVFOTP",
  async (phone: string) => {
    const data = {
      method: "sendNvfOtp",
      msisdn: phone?.replace(/[^\d]/g, ""),
      langId: "tr_TR",
      msgPrefix: "FIXC2D",
      USER_AGENT: "WEB",
    };
    const res = await instance
      .post("/", data, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((response) => response.data);

    return res;
  }
);

export const sendVFOTP = createAsyncThunk<any, any>(
  "sendVFOTP",
  async (phone: string) => {
    const data = {
      method: "sendSessionOtp",
      msisdn: phone?.replace(/[^\d]/g, ""),
      langId: "tr_TR",
      msgPrefix: "FIXC2D",
      USER_AGENT: "WEB",
    };
    const res = await instance
      .post("/", data, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((response) => response.data);

    return res;
  }
);

export const createNVFSession = createAsyncThunk<any, any>(
  "createNVFSession",
  async (data) => {
    const { otp, sid } = data as any;
    const params = new URLSearchParams();
    params.append("method", "createNvfSession");
    params.append("otpCode", otp);
    params.append("sid", sid);
    params.append("langId", "tr_TR");
    params.append("USER_AGENT", "WEB");

    const res = await instance
      .post("/", params, {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
        },
      })
      .then((response) => response.data);

    return res;
  }
);

export const getSessionTrackingData = createAsyncThunk<any, any>(
  "createNVFSessionSMS",
  async (data) => {
    const params = new URLSearchParams();
    params.append("method", "getSessionTrackingData");
    console.log(data.replace(/ /g, '+'))
    const datax = data.replaceAll(/ /g, '+')
    const res = await instance
      .post("/", { data: datax }, {
        params: params,
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then((response) => response.data);

    return res;
  }
);

export const createNVFSessionSMS = createAsyncThunk<any, any>(
  "createNVFSessionSMS",
  async (data) => {
    const { sid } = data as any;
    const params = new URLSearchParams();
    params.append("method", "createNvfSession");
    params.append("sid", sid);
    params.append("langId", "tr_TR");
    params.append("USER_AGENT", "WEB");

    const res = await instance
      .post("/", params, {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
        },
      })
      .then((response) => response.data);

    return res;
  }
);

export const createVFSessionSMS = createAsyncThunk<any, any>(
  "createVFSessionSMS",
  async (data) => {
    const { sid } = data as any;
    const params = new URLSearchParams();
    params.append("method", "createSession");
    params.append("sid", sid);
    params.append("langId", "tr_TR");
    params.append("USER_AGENT", "WEB");
    params.append("savedToken", "true");

    const res = await instance
      .post("/", params, {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
        },
      })
      .then((response) => response.data);

    return res;
  }
);

export const createVFSession = createAsyncThunk<any, any>(
  "createVFSession",
  async (data) => {
    const { otp, sid } = data as any;
    const params = new URLSearchParams();
    params.append("method", "createSession");
    params.append("otpCode", otp);
    params.append("sid", sid);
    params.append("langId", "tr_TR");
    params.append("USER_AGENT", "WEB");
    params.append("rememberMe", "true");

    const res = await instance
      .post("/", params, {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
        },
      })
      .then((response) => response.data);

    return res;
  }
);

export const CreateSession = createAsyncThunk("CreateSession", async () => {
  const params = new URLSearchParams();
  params.append("method", "createSession");
  //params.append("clientVersion", "12");
  params.append("USER_AGENT", "WEB");
  params.append("platformName", "WEB");
  params.append("langId", "tr_TR");
  // params.append("msisdn", "5555555555");
  // params.append("password", "11111111");

  const res = await axios
    .post(`${process.env.NEXT_PUBLIC_AUTO_LOGIN_SERVICE}`, null, {
      params,
      timeout: 8000,
    })
    .then((response) => response.data)
    .catch((error) => console.log(error));

  return res;
});

export const CheckAuth = createAsyncThunk("CheckAuth", async () => {
  const res = await axios
    .get("https://www.vodafone.com.tr/api/member/checkAuth", {
      timeout: 8000,
    })
    .then((response) => response.data)
    .catch((error) => console.log(error));
  return res;
});
